export default __webpack_public_path__ + "static/logo_EFTB_BM-6140736b9c6300efd2516026018b30c0.png";